import { render, staticRenderFns } from "./TechnicianSetting.vue?vue&type=template&id=128ee322"
import script from "./TechnicianSetting.vue?vue&type=script&lang=js"
export * from "./TechnicianSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports